import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@material-ui/core';
import { Flex } from '@knockrentals/knock-shared-web-v2';
import TabSectionHeader from './TabSectionHeader';
import { makeCss } from '../../../../../../knock-design-system';

const useCss = makeCss({
  headerTitle: {
    width: '200px',
    minWidth: '200px',
  },
  sectionContent: {
    flex: 1,
    minWidth: '797px',
  },
  wrapper: {
    marginTop: '24px',
  },
});

const DividedTabSection = ({
  children,
  description,
  isDividerHidden,
  title,
}) => {
  const css = useCss();

  return (
    <div css={css.wrapper}>
      <Flex gap={24} mb={'24px'}>
        <TabSectionHeader
          css={css.headerTitle}
          description={description}
          title={title}
        />

        <div css={css.sectionContent}>{children}</div>
      </Flex>
      {!isDividerHidden && <Divider />}
    </div>
  );
};

DividedTabSection.propTypes = {
  children: PropTypes.node,
  description: PropTypes.string,
  isDividerHidden: PropTypes.bool,
  title: PropTypes.string,
};

export default DividedTabSection;
